import {FormattedMessage} from "react-intl";
import React from "react";

export const faqCardsBody = (index) => {
    switch (index){
        case 1:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.recruit.questions.question_1.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.recruit.questions.question_1.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.recruit.questions.question_1.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 2:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.recruit.questions.question_2.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.recruit.questions.question_2.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.recruit.questions.question_2.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.recruit.questions.question_2.body.list_item_2"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.recruit.questions.question_2.body.list_item_3"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.recruit.questions.question_2.body.list_item_4"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.recruit.questions.question_2.body.list_item_5"
                                defaultMessage="" />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="faq.recruit.questions.question_2.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                </div>
            )
        default:
            return (<></>)
    }
}

export const faqCardsHeader = (index) => {
    switch (index){
        case 1:
            return (<FormattedMessage
                id="faq.recruit.questions.question_1.title"
                defaultMessage="Comment trouver un métier dans le digital qui vous convienne ?" />)
        case 2:
            return (<FormattedMessage
                id="faq.recruit.questions.question_2.title"
                defaultMessage="Quels sont les métiers du digital qui recrutent actuellement et quels sont les postes les plus demandés ?" />)

        default:
            return (<FormattedMessage
                id="faq.recruit.title"
                defaultMessage="Nous répondons à vos questions" />)
    }
}
